import { USER_ROLES } from '../ac/constants'

function sameId (left, right) {
  if (left == null || right == null) return false
  return String(left) === String(right)
}

export function isStaffMapRegionRole (roleId) {
  return roleId === USER_ROLES.SUPER_ADMIN
    || roleId === USER_ROLES.ADMINISTRATOR
    || roleId === USER_ROLES.OPERATOR
    || roleId === 'admin'
}

export function isUnrestrictedViewer (profile) {
  if (!profile?.roleId) return false
  return profile.roleId === USER_ROLES.SUPER_ADMIN || profile.roleId === USER_ROLES.ADMINISTRATOR
}

export function filterRowsByViewerScope (profile, rows, {
  idAttribute = 'id',
  userIdAttribute
} = {}) {
  if (!Array.isArray(rows) || isUnrestrictedViewer(profile)) {
    return rows ?? []
  }

  const assignedDeviceIds = new Set((profile?.deviceIds ?? []).map(id => String(id)))
  const assignedUserIds = new Set((profile?.assignedUserIds ?? []).map(id => String(id)))
  if (profile?.id != null) {
    assignedUserIds.add(String(profile.id))
  }

  return rows.filter(row => {
    if (userIdAttribute) {
      const userId = row[userIdAttribute]
      if (userId != null && assignedUserIds.has(String(userId))) {
        return true
      }
      return false
    }

    const rowId = row[idAttribute]
    return rowId != null && assignedDeviceIds.has(String(rowId))
  })
}

export function filterFamilyOptionsByViewerScope (profile, familyOptions) {
  if (!Array.isArray(familyOptions) || isUnrestrictedViewer(profile)) {
    return familyOptions ?? []
  }

  const visibleFamilyIds = new Set(
    (profile?.visibleFamilyIds ?? [profile?.familyId])
      .filter(Boolean)
      .map(id => String(id))
  )

  return familyOptions.filter(option => {
    if (option?.value === '' || option?.value == null) {
      return true
    }
    return visibleFamilyIds.has(String(option.value))
  })
}

function isStaffCreatedMapRegion (region, viewerId) {
  if (region?.userId == null) return true
  if (sameId(region?.userId, viewerId)) return true
  if (region?.ownerRoleId === USER_ROLES.CLIENT) return false
  return isStaffMapRegionRole(region?.ownerRoleId)
}

/**
 * Clients see only regions they created.
 * Operator / administrator / super-admin share staff-created regions and never see client-created ones.
 */
export function filterMapRegionsByViewerScope (profile, regions) {
  if (!Array.isArray(regions)) {
    return []
  }

  if (!profile?.roleId) {
    return regions
  }

  if (profile.roleId === USER_ROLES.CLIENT) {
    return regions.filter(region => sameId(region?.userId, profile?.id))
  }

  if (isStaffMapRegionRole(profile.roleId)) {
    return regions.filter(region => isStaffCreatedMapRegion(region, profile.id))
  }

  return regions
}

export function canViewerAccessFamily (profile, familyId) {
  if (familyId == null || familyId === '') return true
  if (isUnrestrictedViewer(profile)) return true

  const visibleFamilyIds = profile?.visibleFamilyIds ?? [profile?.familyId]
  return visibleFamilyIds.some(candidate => sameId(candidate, familyId))
}
